import styled, { css } from 'styled-components';
import { useBreakpoints } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix, MOBILE_WIDTH_POPUP } from '../../../constants';
import { useLockBodyScroll } from '../../helpers';
import { Comments } from '../common/comments';
import { Player } from '../videos/video';
import { Info } from '../videos/video/info';

export const PopupItem = ({ popupItem, nextVideo }) => {
  const { popupElements, popupWidth } = useSettings();
  const [breakpoints, ref] = useBreakpoints(MOBILE_WIDTH_POPUP);

  const isMobile = breakpoints[MOBILE_WIDTH_POPUP];

  const {
    metadata: {
      connections: {
        comments: { total, uri }
      }
    }
  } = popupItem;

  useLockBodyScroll();

  return (
    <Component
      onClick={(e) => e.stopPropagation()}
      ref={ref}
      _isInPopupWidth={popupWidth}
      _isMobile={isMobile}
    >
      <Item>
        <Player item={popupItem} nextVideo={nextVideo} />
      </Item>

      <InfoWrapper _hasPopupElements={!!popupElements.length}>
        <Info
          data={popupItem}
          elements={popupElements}
          showShare={popupElements.includes('shareButton')}
          popup
        />

        {total > 0 && popupElements.includes('comments') && (
          <Comments source={uri} total={total} />
        )}
      </InfoWrapper>
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-popup-item-component`
})`
  width: 100%;
  background-color: #fff;
  margin-top: 72px;
  margin-bottom: 40px;
  max-width: ${({ _isInPopupWidth }) => _isInPopupWidth || 800}px;

  & .${classnamePrefix}-info-time {
    ${({ _isMobile }) =>
      _isMobile &&
      css`
        font-size: 12px;
        line-height: 16px;
      `}
  }

  & .${classnamePrefix}-info-name {
    font-size: 24px;
    line-height: 32px;
  }

  & .${classnamePrefix}-info-name, & .${classnamePrefix}-comments-title {
    ${({ _isMobile }) =>
      _isMobile &&
      css`
        font-size: 14px;
        line-height: 20px;
      `}
  }

  &
    .${classnamePrefix}-info-description,
    &
    .${classnamePrefix}-user-name,
    &
    .${classnamePrefix}-comments-item-authorName,
    &
    .${classnamePrefix}-comments-item-text,
    &
    .${classnamePrefix}-comments-item-authorDate,
    &
    .${classnamePrefix}-read-more-button {
    ${({ _isMobile }) =>
      _isMobile &&
      css`
        font-size: 12px;
        line-height: 16px;
      `}
  }

  & .${classnamePrefix}-info-name {
    margin-top: 0;
  }
`;

const Item = styled.div.attrs({
  className: `${classnamePrefix}-popup-item-item`
})``;

const InfoWrapper = styled.div.attrs({
  className: `${classnamePrefix}-popup-item-info`
})`
  padding: ${({ _hasPopupElements }) => (_hasPopupElements ? '20px' : '0')};
`;
